import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from '@src/shell/utils/Formatter'
import { QueueRefreshError } from '@src/tools/dead-letter/types/QueueTypes'

interface Props {
  errors: QueueRefreshError[]
}

const QueueRefreshErrors = ({ errors }: Props) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
        {t('queues.refreshErrors')}
      </Typography>

      {errors.length === 0 ? (
        <Typography color="text.secondary">{t('queues.noRefreshErrors')}</Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>{t('queues.storageAccount')}</TableCell>
              <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>{t('queues.errorCode')}</TableCell>
              <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>{t('queues.errorMessage')}</TableCell>
              <TableCell sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}>{t('queues.occurredOn')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {errors.map((e) => (
              <TableRow key={e.id}>
                <TableCell sx={{ fontSize: '0.8rem' }}>
                  {e.friendlyName}{' '}
                  <Typography component="span" variant="caption" sx={{ color: 'text.secondary' }}>
                    ({e.storageAccountName})
                  </Typography>
                </TableCell>
                <TableCell sx={{ fontSize: '0.8rem' }}>{e.httpStatusCode}</TableCell>
                <TableCell sx={{ fontSize: '0.8rem', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {e.errorMessage}
                </TableCell>
                <TableCell sx={{ fontSize: '0.8rem' }}>{formatDateTime(new Date(e.occurredOn))}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}

export default QueueRefreshErrors
